import React, { useContext, useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import "../css/signup.css";
import UserContext from "../context/users/UserContext";
import { ToastContainer, toast } from "react-toastify";

function Signup(props) {
  const history = useHistory();

  useEffect(() => {
    if (localStorage.getItem("auth-token")) {
      return history.push("/");
    }
    // eslint-disable-next-line
  }, []);
  // eslint-disable-next-line
  const context = useContext(UserContext);
  // console.log(context); //edit here

  const [details, Udetails] = useState({
    name: "",
    email: "",
    password: "",
    cpassword: "",
  });

  const updateDetails = (e) => {
    Udetails((prev) => {
      return { ...prev, [e.target.name]: e.target.value };
    });
    validateEmail(details.email);
  };

  const validateEmail = (usersMail) => {
    //eslint-disable-next-line
    let mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (usersMail.match(mailformat)) {
      return true;
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const detailsToSubmit = {
      name: details.name,
      email: details.email,
      password: details.password,
    };
    const createUser = async () => {
      try {
        // const host = "http://localhost:8000";
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}auth/createuser`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(detailsToSubmit),
          }
        );
        const data = await response.json();
        if (!data.success) {
          toast.error("Email Already Exists");
          Udetails(() => {
            return { name: "", email: "", password: "", cpassword: "" };
          });
        }
        if (data.success) {
          toast.success("Account Created");
          setTimeout(() => {
            history.push("/login");
          }, 2000);
        }
      } catch (error) {
        toast.error("Some Error Occured ! TRY AGAIN");
      }
    };
    createUser();
  };

  return (
    <div>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Link className="bth" to="/">
        &#60; Back To Home
      </Link>
      <div className="signupcontainer">
        <form className="signupbox" onSubmit={handleSubmit}>
          <div className="formControl">
            <h1>SignUp</h1>
          </div>
          <div className="formControl">
            <label htmlFor="name">NAME (MIN LENGTH-3)</label>
            <br />
            <br />
            <input
              className={details.name.length >= 3 && "successBorder"}
              type="name"
              name="name"
              minLength="3"
              onChange={updateDetails}
              value={details.name}
              required
            />
          </div>
          <div className="formControl">
            <label htmlFor="email">EMAIL</label>
            <br />
            <br />
            <input
              className={validateEmail(details.email) && "successBorder"}
              type="email"
              name="email"
              onChange={updateDetails}
              value={details.email}
              required
            />
          </div>
          <div className="formControl">
            <label htmlFor="password">PASSWORD (MIN LENGTH-8)</label>
            <br />
            <br />
            <input
              className={details.password.length >= 8 && "successBorder"}
              type="password"
              name="password"
              minLength="8"
              onChange={updateDetails}
              value={details.password}
              required
            />
          </div>
          <div className="formControl">
            <label htmlFor="cpassword">CONFIRM PASSWORD</label>
            <br />
            <br />
            <input
              className={
                details.password === details.cpassword &&
                details.password !== "" &&
                details.password.length >= 8
                  ? "successBorder"
                  : undefined
              }
              type="password"
              name="cpassword"
              minLength="8"
              onChange={updateDetails}
              value={details.cpassword}
              required
            />
          </div>
          <div className="formControl">
            <button
              type="submit"
              className={
                details.name.length >= 3 &&
                validateEmail(details.email) &&
                details.password === details.cpassword &&
                details.password !== "" &&
                details.password.length >= 8
                  ? "submitok"
                  : undefined
              }
              disabled={
                details.password === details.cpassword &&
                details.password !== ""
                  ? false
                  : true
              }
            >
              SIGNUP
            </button>
          </div>

          <div className="formControl">
            <div>
              Already have an account? <Link to="login">Login</Link>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Signup;
